// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B9bsP","fullView":"styles_fullView__3qvGk"};